import { WaitingRoom } from '../models/waiting-room.model'

/**
 * Some backend `waiting_room_updated` broadcasts emit the room with UNPOPULATED consultations
 * (raw ObjectId strings) instead of populated documents. The waiting-room queue filters on
 * `consultation.status === Scheduled`, which is `undefined` for a bare id — so merging an
 * unpopulated payload over the cached populated list makes every patient disappear from the queue.
 *
 * An empty array counts as populated (`.every()` is `true`), so a room that was legitimately
 * emptied still clears. A missing/non-array `consultations` is treated as unpopulated (kept).
 */
export function consultationsLookPopulated(room: Pick<WaitingRoom, 'consultations'>): boolean {
  return Array.isArray(room.consultations) && room.consultations.every((c: any) => c && typeof c === 'object' && '_id' in c)
}

/**
 * Merge a broadcast waiting-room update into the cached room IN PLACE (so it works inside RTK
 * Query's immer-backed `updateCachedData` draft). When the incoming consultations are not
 * populated, keep the cached consultations and apply the rest of the update.
 */
export function mergeWaitingRoomUpdate(cached: WaitingRoom, incoming: WaitingRoom): WaitingRoom {
  if (consultationsLookPopulated(incoming)) return Object.assign(cached, incoming)
  return Object.assign(cached, { ...incoming, consultations: cached.consultations })
}
